module.exports = __webpack_public_path__ + "static/img/simplifySalesCard.525a37b3.png";